<template>
  <div class="main_photo_container">
    <nav class="nav_photo">
      <div class="logo">
        <img
          src="https://brandclubwholesale.com/wp-content/uploads/2022/06/Logo.webp"
          alt="Logo"
        />
      </div>
      <div class="title">
        <h1 class="title_text">{{ title }}</h1>
      </div>
    </nav>
    <div class="gallery">
      <div class="slider">
        <img
          v-for="(image, index) in images"
          :key="index"
          :src="image.url"
          :alt="image.title"
          :class="{ active: index === activeIndex }"
        />
        <div class="slider-controls">
          <button class="button-container" @click="previousSlide">
            <v-icon class="white-icon">mdi-chevron-left</v-icon>
          </button>
          <button class="button-container" @click="nextSlide">
            <v-icon class="white-icon">mdi-chevron-right</v-icon>
          </button>
        </div>
        <div>
          <a class="donwload-btn" :href="images[activeIndex].download" download>
            Download image</a
          >
        </div>
      </div>
      <div class="thumbnails">
        <img
          v-for="(image, index) in images"
          :key="index"
          :src="image.url"
          :alt="image.title"
          :class="{ active: index === activeIndex }"
          @click="selectSlide(index)"
        />
      </div>
    </div>
    <!-- <v-btn @click="downloadItem" class="download_all"
      >Download all images</v-btn
    > -->
    <div class="footer_photo">
      <span class="footer_text">
        © <a href="https://brandclubwholesale.com" target="_blank">Brandclubwholesale.com</a>
        {{ new Date().getFullYear() }}
      </span>
    </div>
  </div>
</template>

<script>
import StatusInfo from "./../organisms/StatusInfo.vue";
import axios from "axios";
import JSZip from "jszip";
import { saveAs } from "file-saver";

export default {
  name: "WHPhotos",
  data: () => ({
    pending: true,
    filename: "",
    responseMessage: "",
    statusDialog: true,
    textColor: "",
    images: [],
    FeaturedImage: "",

    activeIndex: 0,
    title: "",
  }),
  computed: { StatusInfo },

  watch: {},

  mounted() {
    this.statusDialog = true;
    this.pending = true;
    this.fetchImages();
  },

  methods: {
    downloadItem() {
      const zip = new JSZip();

      const promises = this.images.map((img, index) => {
        return fetch(img.download)
          .then((response) => response.blob())
          .then((blob) => {
            const filename = `image-${index}.jpg`;
            zip.file(filename, blob);
          });
      });

      Promise.all(promises).then(() => {
        zip.generateAsync({ type: "blob" }).then((content) => {
          saveAs(content, "images.zip");
        });
      });
    },

    convertImageToBase64(imgUrl, callback) {
      const image = new Image();
      var dataUrl;
      image.onload = () => {
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");
        canvas.height = image.naturalHeight;
        canvas.width = image.naturalWidth;
        ctx.drawImage(image, 0, 0);
        dataUrl = canvas.toDataURL();
        callback && callback(dataUrl);
      };
      image.src = imgUrl;
      return dataUrl;
    },
    async fetchImages() {
      console.log(this.$route.params.id);
      await axios
        .get("/api/WHProduct/WHPhoto/" + this.$route.params.id)
        .then((res) => {
          this.images = res.data.Images;
          this.FeaturedImage = res.data.featuredImage;
          this.pending = false;
          this.statusDialog = false;
          this.title = res.data.title;
        })
        .catch((err) => {
          this.responseMessage = err.response.data;
          this.statusDialog = true;
          this.filename = "server_down.svg";
        });
    },
    closeStatusDialog() {
      this.statusDialog = false;
    },
    previousSlide() {
      this.activeIndex =
        this.activeIndex === 0 ? this.images.length - 1 : this.activeIndex - 1;
    },
    nextSlide() {
      this.activeIndex =
        this.activeIndex === this.images.length - 1 ? 0 : this.activeIndex + 1;
    },
    selectSlide(index) {
      this.activeIndex = index;
    },
  },
};
</script>
<style>
.main_photo_container {
  background-image: url("./../../assets/logo_bc.png");
  background-repeat: repeat;
  min-height: 100vh;
  background-size: 15%; /* Change background size as desired */
}
.gallery {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}

.slider {
  position: relative;
  width: 800px;
  height: 550px;
  background-color: #fff;
  border: 1px solid lightgray;
}

.slider img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 0.5s ease;
  object-fit: contain;
}

.slider img.active {
  opacity: 1;
}

.slider-controls {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0.8em;
}

.slider-controls button {
  border: none;
  color: #fff;
  font-size: 2rem;
  cursor: pointer;
  transition: opacity 0.3s ease;
  background-color: #0000006e;
  border-radius: 100%;

  display: flex;
  width: 35px;
  height: 35px;
  align-items: center;
  justify-content: center;
}

.slider-controls button:hover {
  opacity: 0.7;
}

.thumbnails {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 20px;
}

.thumbnails img {
  width: 100px;
  height: 100px;
  margin: 5px;
  cursor: pointer;
  opacity: 0.7;
  transition: opacity 0.3s ease;
}

.thumbnails img:hover {
  opacity: 1;
}
.white-icon.mdi-chevron-left::before {
  color: white;
  width: 25px;
}
.white-icon.mdi-chevron-right::before {
  color: white;
  width: 25px;
}
.white-icon.mdi-download::before {
  color: white;
  width: 25px;
}
.donwload-btn {
  position: absolute;
  color: black !important;
  border: 1px solid black;
  padding: 0.5em;
  right: 10px;
  top: 10px;
}
@media screen and (max-width: 792px) {
  .slider {
    width: 800px;
    height: 300px;
  }
}
.productTitle {
  padding: 1.75em;
  text-align: center;
  font-size: 28px;
}
.nav_photo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  background-color: #d3d3d395;
  color: #fff;
  margin-bottom: 2.5em;
}

.logo img {
  height: 50px;
}

.title {
  flex-grow: 1;
  color: antiquewhite;
  text-align: center;
}

.title h1 {
  font-size: 24px;
}
.footer_photo {
  margin-top: 2.5em;
  padding: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #d3d3d395;
  position: absolute;
  bottom: -63px;
  width: 100% !important;
}
.footer_text {
  margin: 0 !important;
}
.footer_photo a {
  color: black !important;
  text-decoration: underline;
}
@media only screen and (max-width: 768px) {
  .nav_photo {
    flex-direction: column;
    justify-content: center;
    text-align: center;
  }

  .logo,
  .title {
    margin-bottom: 20px;
  }
}
.title_text {
  color: rgba(5, 5, 5, 1);
}
.download_all {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5em;
}
</style>
